/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 *
 * @export
 * @interface NewShopOrder
 */
export interface NewShopOrder {
  /**
   *
   * @type {number}
   * @memberof NewShopOrder
   */
  courierId?: number;
  /**
   *
   * @type {number}
   * @memberof NewShopOrder
   */
  customerId?: number;
  /**
   *
   * @type {string}
   * @memberof NewShopOrder
   */
  status?: string;
  /**
   *
   * @type {number}
   * @memberof NewShopOrder
   */
  totalAmount?: number;
  /**
   *
   * @type {string}
   * @memberof NewShopOrder
   */
  paymentMethod?: string;
  /**
   *
   * @type {string}
   * @memberof NewShopOrder
   */
  paymentStatus?: string;
  /**
   *
   * @type {string}
   * @memberof NewShopOrder
   */
  paymentReference?: string;
  /**
   *
   * @type {string}
   * @memberof NewShopOrder
   */
  proofOfPayment?: string;
  /**
   *
   * @type {string}
   * @memberof NewShopOrder
   */
  notes?: string;
  /**
   *
   * @type {string}
   * @memberof NewShopOrder
   */
  guestName?: string;
  /**
   *
   * @type {string}
   * @memberof NewShopOrder
   */
  guestEmail?: string;
  /**
   *
   * @type {string}
   * @memberof NewShopOrder
   */
  guestPhone?: string;
  /**
   *
   * @type {boolean}
   * @memberof NewShopOrder
   */
  isGuestOrder?: boolean;
  /**
   *
   * @type {Date}
   * @memberof NewShopOrder
   */
  createdAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof NewShopOrder
   */
  updatedAt?: Date;
}

/**
 * Check if a given object implements the NewShopOrder interface.
 */
export function instanceOfNewShopOrder(
  value: object
): value is NewShopOrder {
  return true;
}

export function NewShopOrderFromJSON(json: any): NewShopOrder {
  return NewShopOrderFromJSONTyped(json, false);
}

export function NewShopOrderFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): NewShopOrder {
  if (json == null) {
    return json;
  }
  return {
    courierId: json['courierId'] == null ? undefined : json['courierId'],
    customerId: json['customerId'] == null ? undefined : json['customerId'],
    status: json['status'] == null ? undefined : json['status'],
    totalAmount: json['totalAmount'] == null ? undefined : json['totalAmount'],
    paymentMethod: json['paymentMethod'] == null ? undefined : json['paymentMethod'],
    paymentStatus: json['paymentStatus'] == null ? undefined : json['paymentStatus'],
    paymentReference: json['paymentReference'] == null ? undefined : json['paymentReference'],
    proofOfPayment: json['proofOfPayment'] == null ? undefined : json['proofOfPayment'],
    notes: json['notes'] == null ? undefined : json['notes'],
    guestName: json['guestName'] == null ? undefined : json['guestName'],
    guestEmail: json['guestEmail'] == null ? undefined : json['guestEmail'],
    guestPhone: json['guestPhone'] == null ? undefined : json['guestPhone'],
    isGuestOrder: json['isGuestOrder'] == null ? undefined : json['isGuestOrder'],
    createdAt: json['createdAt'] == null ? undefined : new Date(json['createdAt']),
    updatedAt: json['updatedAt'] == null ? undefined : new Date(json['updatedAt']),
  };
}

export function NewShopOrderToJSON(json: any): NewShopOrder {
  return NewShopOrderToJSONTyped(json, false);
}

export function NewShopOrderToJSONTyped(
  value?: NewShopOrder | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    courierId: value['courierId'],
    customerId: value['customerId'],
    status: value['status'],
    totalAmount: value['totalAmount'],
    paymentMethod: value['paymentMethod'],
    paymentStatus: value['paymentStatus'],
    paymentReference: value['paymentReference'],
    proofOfPayment: value['proofOfPayment'],
    notes: value['notes'],
    guestName: value['guestName'],
    guestEmail: value['guestEmail'],
    guestPhone: value['guestPhone'],
    isGuestOrder: value['isGuestOrder'],
    createdAt: value['createdAt'] == null ? undefined : value['createdAt'].toISOString(),
    updatedAt: value['updatedAt'] == null ? undefined : value['updatedAt'].toISOString(),
  };
}
